export const cvData = [
    {
        "lang":'fr',
        "date":'07/08/2025',
        "title":`CV - Version française`,
        "desc":`Mon CV détaillant mon parcours académique, mes expériences professionnelles, mes compétences techniques.`,
        "googleId":`1F-4JpYMRZU8Q6PsDn_XuJfPjK-m8_L4P`,
        "tags":['cv']
    },
]